import { Component, h, Host, Element } from '@stencil/core';
import { checkSlottedContentForInvalidHTML } from '../../../global/utils/utils';
/**
 * @slot banner - This slot is reserved for a banner component
 * @slot sub-banner - This slot is reserved for a sub banner area that is the full width of the page ( contents is centered)
 * @slot contents - Contents in this slot will placed center section of the page
 */
export class SimpleContainerComponent {
  constructor() {
    this.hasSubBanner = false;
  }
  componentWillLoad() {
    this.hasSubBanner = !!this.host.querySelector('[slot="sub-banner"]');
    checkSlottedContentForInvalidHTML(this.host.querySelector('[slot="banner"]'), [
      'div',
      'agl-ds-simple-container',
      'agl-ds-banner-simple'
    ]);
  }
  render() {
    return (h(Host, null,
      h("div", { class: "banner " },
        h("div", { class: "grid-container" },
          h("div", { class: "row" },
            h("div", { class: "col-sm-12 col-md-8 col-md-offset-2  col-lg-10 col-lg-offset-1" },
              h("slot", { name: "banner" }))))),
      this.hasSubBanner && (h("div", { class: "sub-banner " },
        h("div", { class: "grid-container" },
          h("div", { class: "row" },
            h("div", { class: "col-sm-12 col-md-8 col-md-offset-2  col-lg-10 col-lg-offset-1" },
              h("slot", { name: "sub-banner" })))))),
      h("div", { class: "content grid-container" },
        h("div", { class: "row" },
          h("div", { class: "col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 " },
            h("slot", { name: "content" }))))));
  }
  static get is() { return "agl-ds-simple-container"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["simple-container.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["simple-container.component.css"]
  }; }
  static get elementRef() { return "host"; }
}
